import angular from 'angular';
import _ from 'lodash';
import * as searchItemsPriority from '../../constants/searchItemsPriority';
import { INCLUDED, EXCLUDED, CURRENTLY_NOT } from './../../constants/tagAdditionalText';

const SEPARATOR = ' <strong>/</strong> ';
const TOOLTIP_SEPARATOR = ' • ';

export const DynamicCriteriaWithGroupsService = (RouteService, TFTTagsService, $sce) => {
    const MAX_GROUP_ITEMS_TO_DISPLAY = RouteService.getSystemDefaults('minGroupSkillsCount') || 3;

    const getItemValueToDisplay = (item) => {
        if (item) {
            if (item.hasOwnProperty('group') && _.isArray(item.group)) {
                const elementsToDisplay = item.group.slice(0, MAX_GROUP_ITEMS_TO_DISPLAY);
                const restElementsCount = item.group.slice(MAX_GROUP_ITEMS_TO_DISPLAY).length;

                const values = _.map(elementsToDisplay || [], 'value');

                if (restElementsCount > 0) {
                    values.push(`+${restElementsCount}`);
                }

                return values.join(SEPARATOR);
            }
            const value = _.get(item, 'text', _.get(item, 'value', ''));
            const additional = _.get(item, 'additional.text', _.get(item, 'additional.value', ''));
            const filteredAdditional = (additional && ![INCLUDED, EXCLUDED, CURRENTLY_NOT].includes(additional)) ? `, ${additional}` : '';

            return `${value}${filteredAdditional}`;
        }
    };

    const getItemHtmlToDisplay = (item, groupPriority) => {
        if (item) {
            const priority = groupPriority || item.required;
            const text = getItemValueToDisplay(item);

            const additional = _.get(item, 'additional.text', _.get(item, 'additional.value', ''));

            const isExcluded = (additional && [EXCLUDED, CURRENTLY_NOT].includes(additional));
            const { className, styles } = TFTTagsService.getTagStyles({ priority, isExcluded });
            const stylesStr = Object.entries(styles).map(([key, value]) => `${key}: ${value} !important;`).join(' ');

            return $sce.trustAsHtml(`<div class="tft-tags-list-item__wrapper ${className}" style="${stylesStr}">
                        ${text}
                    </div>`);
        }
    };

    const getItemTooltip = (item) => {
        if (item) {
            if (item.hasOwnProperty('group') && item.group.length > MAX_GROUP_ITEMS_TO_DISPLAY) {
                const values = _.map(item.group || [], 'value');
                return values.join(TOOLTIP_SEPARATOR);
            }
        }
    };

    const getMatchedItemIndex = ({ list = [], item }) => {
        const itemToMoveIndex = _.findIndex(list, (originalItem) => {
            const getItemValuableFields = item => (({ required, value }) => ({ required, value }))(item);

            const originalGroupItemValuableFields = _.map(originalItem.group || [], item => getItemValuableFields(item));
            const droppedGroupItemValuableFields = _.map(item.group || [], item => getItemValuableFields(item));
            const isSameItem = originalItem.required === item.required
                && originalItem.value === item.value
                && _.isEqual(originalGroupItemValuableFields, droppedGroupItemValuableFields);
            return isSameItem;
        });

        return itemToMoveIndex;
    };

    const getMaxItemsPriority = (items) => {
        const prioritiesCount = 4;
        const itemsSortedByPriority = _.sortBy(items, (item) => {
            switch (item.required) {
                case searchItemsPriority.OPTIONAL:
                    return prioritiesCount;
                case searchItemsPriority.MANDATORY:
                    return prioritiesCount - 1;
                case searchItemsPriority.PREFERRED:
                    return prioritiesCount - 2;
                case searchItemsPriority.FILTER:
                    return prioritiesCount - 3;
                default:
                    return prioritiesCount + 1;
            }
        });

        return _.get(itemsSortedByPriority, '[0].required');
    };

    const cleanUpItemFields = item => (({ text, value, uid }) => ({ text, value, uid }))(item);

    return {
        cleanUpItemFields,
        getMatchedItemIndex,
        getMaxItemsPriority,
        getItemValueToDisplay,
        getItemHtmlToDisplay,
        getItemTooltip,
    };
};

angular.module('TALENYA-FE').factory('DynamicCriteriaWithGroupsService', DynamicCriteriaWithGroupsService);
